import { Injectable } from '@angular/core';
import {ApiHttpService, ApiListResult, ApiService, ListOptions} from "@capturum/api";
import {Observable} from "rxjs";
import {Field} from "@shared/field/field.enum";

@Injectable({
  providedIn: 'root'
})
export class RegionAnalysisService extends ApiService<any> {

    protected endpoint = 'dashboard-rmc/region-analysis';

    constructor(apiHttp: ApiHttpService) {
        super(apiHttp);
    }

    public getAvailableRegionYears(): Observable<ApiListResult> {
        return this.apiHttp.get(`/${this.endpoint}/list-available-region-years`);
    }

    public downloadFile(year: string): Observable<Blob> {
        return this.apiHttp.getBlob(`/${this.endpoint}/export/${year}`, '');
    }
}
